export default "__VITE_ASSET__CYXG_0Ox__"